import { render } from "./ThanksView.vue?vue&type=template&id=9df2fb94&scoped=true"
import script from "./ThanksView.vue?vue&type=script&lang=js"
export * from "./ThanksView.vue?vue&type=script&lang=js"

import "./ThanksView.vue?vue&type=style&index=0&id=9df2fb94&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9df2fb94"]])

export default __exports__